// src/modules/app-views/account/pages/Subscription/tabs/VoipGotoTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleLoadingArea from 'components/SimpleComponents/SimpleLoadingArea';
import { useDocumentContext } from 'components/core/DocumentProvider';
import VoipGotoCard from './VoipGotoCard';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const VoipGotoTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, loading } = useDocumentContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      <SimpleLoadingArea name="voipGotoTab" isFetching={loading} data={data} />

      <VoipGotoCard />
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default VoipGotoTab;

// *******************************************************************************
// HELPERS
// *******************************************************************************
